import React from "react";
import { AlertCircle, Filter as FilterIcon, Settings } from "lucide-react";

import { Filter } from "../../../components/ui/Filter";
import { Input } from "../../../components/ui/Form/Input";
import { Select } from "../../../components/ui/Form/Select";
import { CrmPetController } from "../../../services/controllers/crmPet";
import { useCrmPet } from "../../../store/crmPet/useCrmPet";
import {
  CRM_PET_ANALYSIS_DAY_OPTIONS,
  CRM_PET_PRODUCT_CATEGORIES,
  CRM_PET_SERVICE_CATEGORIES,
  CRM_PET_SUBSCRIPTION_OPTIONS,
} from "../constants";

export function CrmPetFilter() {
  const CCrmPet = CrmPetController();
  const filter = useCrmPet((st) => st.data.filter);
  const isLoading = useCrmPet((st) => st.data.isLoading);
  const error = useCrmPet((st) => st.data.error);
  const contextualCategories = filter.rule === "NO_PRODUCT"
    ? CRM_PET_PRODUCT_CATEGORIES
    : filter.rule === "NO_ADDITIONAL"
      ? CRM_PET_SERVICE_CATEGORIES
      : [];
  const showCategoryFilter = ["NO_PRODUCT", "NO_ADDITIONAL"].includes(filter.rule);
  const categoryLabel = filter.rule === "NO_PRODUCT" ? "Produto" : "Serviço";

  return (
    <>
      <Filter.Root className="!flex-col xl:!flex-row" onSubmit={CCrmPet.filterPets}>
        <Filter.Container>
          <Input.Root
            label="Buscar"
            style={{ minWidth: "240px", flex: 1 }}
            value={filter.search}
            onChange={(search) => CCrmPet.setFilter({ search })}
          />
          <Select.Root
            label="Dias"
            value={filter.analysisDays}
            style={{ maxWidth: "105px" }}
            onChange={(analysisDays) => CCrmPet.setFilter({ analysisDays })}
          >
            {CRM_PET_ANALYSIS_DAY_OPTIONS.map((days) => (
              <Select.Option key={days} value={String(days)}>{days}d</Select.Option>
            ))}
          </Select.Root>
          <Select.Root
            label="Contato"
            value={filter.contact}
            style={{ maxWidth: "160px" }}
            onChange={(contact) => CCrmPet.setFilter({ contact })}
          >
            <Select.Option value="ALL">Todos</Select.Option>
            <Select.Option value="CONTACTED">Contatados</Select.Option>
            <Select.Option value="PENDING">Pendentes</Select.Option>
          </Select.Root>
          <Select.Root
            label="Assinatura"
            value={filter.subscription}
            style={{ maxWidth: "185px" }}
            onChange={(subscription) => CCrmPet.setFilter({ subscription })}
          >
            {CRM_PET_SUBSCRIPTION_OPTIONS.map((option) => (
              <Select.Option key={option.value} value={option.value}>{option.label}</Select.Option>
            ))}
          </Select.Root>
          {showCategoryFilter && (
            <Select.Root
              label={categoryLabel}
              value={filter.categoryCode}
              style={{ maxWidth: "210px" }}
              onChange={(categoryCode) => CCrmPet.setFilter({ categoryCode })}
            >
              <Select.Option value="ALL">Todas as categorias</Select.Option>
              {contextualCategories.map((category) => (
                <Select.Option key={category.code} value={category.code}>{category.label}</Select.Option>
              ))}
            </Select.Root>
          )}
        </Filter.Container>
        <Filter.Actions className="flex-wrap justify-end">
          <Filter.Action isLoading={isLoading}>
            <Filter.ActionIcon icon={FilterIcon} isLoading={isLoading} />
            Filtrar
          </Filter.Action>
          <Filter.Action outline type="button" onClick={CCrmPet.clearFilter}>
            Limpar
          </Filter.Action>
          <Filter.Action type="button" onClick={CCrmPet.openConfig} title="Configurações">
            <Filter.ActionIcon icon={Settings} />
          </Filter.Action>
        </Filter.Actions>
      </Filter.Root>

      {error && (
        <div style={{ display: "flex", alignItems: "center", gap: 10, background: "#fef2f2", border: "1px solid #fca5a5", color: "#dc2626", borderRadius: 10, padding: "10px 16px", fontSize: 13 }}>
          <AlertCircle size={15} style={{ flexShrink: 0 }} />
          <span>{error}</span>
          <button onClick={CCrmPet.findPets} style={{ marginLeft: "auto", background: "none", border: "none", cursor: "pointer", color: "#dc2626", textDecoration: "underline", fontSize: 12 }}>
            Tentar novamente
          </button>
        </div>
      )}
    </>
  );
}
